
import _ from "lodash";

export const objectIsEqual = (initialValues, values, deepEqual = false) => {
	const shallowEqual = (object1, object2) => {
		return JSON.stringify(object1) === JSON.stringify(object2);
	}
	return deepEqual ? _.isEqual(initialValues, values) : shallowEqual(initialValues, values)
};


export default objectIsEqual;
